import React from 'react'
import { RiseLoader } from 'react-spinners'
const Loader = () => {
    return (
        <>
            <div className="flex justify-center my-10">
                <RiseLoader color="#36d7b7" />
            </div>
        </>
    )
}

export default Loader